import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classes from './CustomFormDate.module.scss';
import { CustomDatePicker } from '../../';
import { dateFormatter, stringDateFormatter } from '../../../../utils/utils';

const CustomFormDate = (props) => {
    const { inputData, formik } = props;
    if (!inputData?.is_active) return null;

    const onDateChange = (date) => {
        if (!date) return;
        formik.setFieldValue(inputData?.input_id, dateFormatter(date));
    }

    return (
        <div className={classes.CustomFormDate}>
            {inputData?.label ? 
                (<label htmlFor={inputData?.input_id}>
                    {inputData?.label}
                    {inputData?.is_required ? <span className='required'>*</span> : null}
                </label>) 
            : null}
            <CustomDatePicker 
                onChange={(date) => onDateChange(date)}
                placeholderText={inputData?.placeholder}
                selected={stringDateFormatter(formik?.values?.[inputData?.input_id]) || null}
                minDate={new Date('1965-01-01')}
                maxDate={new Date()}
            />
            {inputData?.helper_text ? (
                <span className='helper-text'>{inputData?.helper_text}</span>
            ) : null}
            {formik.touched[inputData?.input_name] && formik.errors[inputData?.input_name] ? (
                <span className="form-error">{formik.errors[inputData?.input_name]}</span>
            ) : null}
        </div>
    )
}

CustomFormDate.propTypes = {}

export default CustomFormDate;